import { render, staticRenderFns } from "./AttendanceAlert.vue?vue&type=template&id=9372cf56"
import script from "./AttendanceAlert.vue?vue&type=script&lang=ts"
export * from "./AttendanceAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports